import React from 'react';

export const G1 = 'linear-gradient(135deg,#667eea,#764ba2)';
export const G2 = 'linear-gradient(135deg,#764ba2,#f093fb)';
export const GE = 'linear-gradient(135deg,#1e3a5f,#0f2544)';
export const GG = 'linear-gradient(135deg,#10b981,#059669)';

// ألوان الأكاديمية الجديدة — كحلي غامق + أكسنت برتقالي
export const NAVY = 'linear-gradient(135deg,#070b1f 0%,#0f1640 50%,#1a1f5c 100%)';
export const OR   = '#f97316';
export const OG   = 'linear-gradient(135deg,#f97316,#fb923c)';

/* ════════════════════════════════════════════════════════════
   خلفية الأكاديمية الموحّدة — كحلي ممتد على عرض الشاشة + كرات طايرة
   تُستخدم في كل الصفحات العامة عشان نفس إحساس صفحة الكورسات.
   (كلاس gw-orb معرّف في SPIN_CSS اللي بيتحقن من App)
   ════════════════════════════════════════════════════════════ */
export function NavyBg({ orbs = true }) {
  return (
    <div aria-hidden style={{ position: 'absolute', top: 0, bottom: 0, left: '50%', marginLeft: '-50vw', width: '100vw', background: NAVY, zIndex: -1, overflow: 'hidden', pointerEvents: 'none' }}>
      {orbs && (
        <>
          <div className="gw-orb" style={{ width: '340px', height: '340px', background: '#f97316', top: '-100px', right: '-70px' }} />
          <div className="gw-orb" style={{ width: '320px', height: '320px', background: '#6366f1', bottom: '-80px', left: '-60px', animationDelay: '-6s' }} />
          <div className="gw-orb" style={{ width: '240px', height: '240px', background: '#8b5cf6', top: '38%', left: '46%', opacity: 0.25, animationDelay: '-3s' }} />
        </>
      )}
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   HeroGlow — وهج تفاعلي بيتبع الماوس في منطقة الهيرو فقط.
   - طبقتين وهج بسرعتين مختلفتين (إحساس عمق) + نجوم خفيفة.
   - على الموبايل (بدون ماوس): حركة تلقائية بطيئة.
   - transform للأداء + pointerEvents none — صفر تأثير على التفاعل.
   يُوضع مباشرة بعد خلفية الصفحة (NavyBg أو ما يعادلها).
   ════════════════════════════════════════════════════════════ */
export function HeroGlow({ height = '92vh', stars = 22 }) {
  const ref = React.useRef(null);
  const starsArr = React.useMemo(
    () => Array.from({ length: stars }, () => ({
      right: Math.random() * 100,
      top: Math.random() * 100,
      delay: Math.random() * 3,
    })),
    [stars]
  );

  React.useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const g1 = el.querySelector('.gw-glow');
    const g2 = el.querySelector('.gw-glow2');
    if (!g1 || !g2) return;

    let tx = window.innerWidth / 2, ty = 240;
    let x1 = tx, y1 = ty, x2 = tx, y2 = ty;
    let raf = 0, iv = 0, alive = true;

    const clampY = (y) => {
      const h = el.getBoundingClientRect().height || 1;
      return Math.max(0, Math.min(y, h));
    };
    const onMove = (e) => {
      const r = el.getBoundingClientRect();
      tx = e.clientX;
      ty = clampY(e.clientY - r.top);
    };

    const hasMouse = window.matchMedia && window.matchMedia('(hover:hover)').matches;
    if (hasMouse) {
      window.addEventListener('mousemove', onMove, { passive: true });
    } else {
      let t = Math.random() * 6;
      iv = setInterval(() => {
        t += 0.008;
        const r = el.getBoundingClientRect();
        tx = r.width * (0.5 + 0.35 * Math.sin(t));
        ty = r.height * (0.45 + 0.25 * Math.cos(t * 1.3));
      }, 40);
    }

    const loop = () => {
      if (!alive) return;
      x1 += (tx - x1) * 0.09; y1 += (ty - y1) * 0.09;
      x2 += (tx - x2) * 0.045; y2 += (ty - y2) * 0.045;
      g1.style.transform = `translate(${x1}px,${y1}px) translate(-50%,-50%)`;
      g2.style.transform = `translate(${x2}px,${y2}px) translate(-50%,-50%)`;
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      alive = false;
      cancelAnimationFrame(raf);
      if (iv) clearInterval(iv);
      if (hasMouse) window.removeEventListener('mousemove', onMove);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      style={{
        position: 'absolute', top: 0, left: '50%', marginLeft: '-50vw',
        width: '100vw', height, overflow: 'hidden',
        pointerEvents: 'none', zIndex: -1,
      }}
    >
      <div className="gw-glow" />
      <div className="gw-glow2" />
      {starsArr.map((s, i) => (
        <span key={i} className="gw-star" style={{ right: s.right + '%', top: s.top + '%', animationDelay: s.delay + 's' }} />
      ))}
    </div>
  );
}

// ستايل الكارت الزجاجي الموحّد (نفس كروت الكورسات)
export const GLASS = {
  background: 'rgba(255,255,255,0.045)',
  border: '1px solid rgba(255,255,255,0.09)',
  borderRadius: '20px',
  boxShadow: '0 10px 30px rgba(0,0,0,0.28)',
};

// جذر الصفحة العامة الموحّد
export const PAGE_ROOT = {
  position: 'relative',
  minHeight: '100vh',
  isolation: 'isolate',
  fontFamily: "'Tajawal', sans-serif",
};

export const INP = {
  width: '100%',
  padding: '12px 14px',
  border: '2px solid #E5E7EB',
  borderRadius: '10px',
  fontSize: '15px',
  boxSizing: 'border-box',
  outline: 'none',
  fontFamily: 'Arial',
};

export const LBL = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: 'bold',
  color: '#374151',
  fontSize: '14px',
};

export const SS = { animation: 'spin 1s linear infinite' };

export const SPIN_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Tajawal:wght@400;500;700;800&display=swap');
  @keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
  @keyframes slideInRight{from{transform:translateX(110%);opacity:0}to{transform:translateX(0);opacity:1}}
  @keyframes slideInLeft{from{transform:translateX(-110%);opacity:0}to{transform:translateX(0);opacity:1}}
  @keyframes fadeInDown{from{transform:translateY(-14px);opacity:0}to{transform:translateY(0);opacity:1}}
  @keyframes badgePop{0%{transform:scale(0)}70%{transform:scale(1.3)}100%{transform:scale(1)}}
  @keyframes cardRise{from{opacity:0;transform:translateY(36px)}to{opacity:1;transform:translateY(0)}}
  @keyframes gwFloat{0%,100%{transform:translateY(0)}50%{transform:translateY(28px)}}
  @keyframes gwPulse{0%,100%{opacity:.55;transform:scale(1)}50%{opacity:.25;transform:scale(1.06)}}
  .gw-card{position:relative;overflow:hidden;transition:transform .38s cubic-bezier(.22,1,.36,1),box-shadow .38s,border-color .38s}
  .gw-card:hover{transform:translateY(-10px);border-color:rgba(249,115,22,.5)!important;box-shadow:0 22px 50px -14px rgba(249,115,22,.42)!important}
  .gw-card::before{content:'';position:absolute;top:0;inset-inline-start:-130%;width:75%;height:100%;background:linear-gradient(120deg,transparent,rgba(255,255,255,.14),transparent);transform:skewX(-20deg);transition:inset-inline-start .7s;pointer-events:none;z-index:3}
  .gw-card:hover::before{inset-inline-start:130%}
  .gw-orb{position:absolute;border-radius:50%;filter:blur(85px);opacity:.4;animation:gwFloat 12s ease-in-out infinite;pointer-events:none}
  /* ── HeroGlow: وهج تفاعلي بيتبع الماوس (طبقتين + نجوم) ── */
  .gw-glow{position:absolute;top:0;left:0;width:520px;height:520px;border-radius:50%;pointer-events:none;filter:blur(70px);opacity:.8;will-change:transform;background:radial-gradient(circle,rgba(147,51,234,.5) 0%,rgba(102,126,234,.32) 35%,rgba(16,185,129,.15) 65%,transparent 80%)}
  .gw-glow2{position:absolute;top:0;left:0;width:300px;height:300px;border-radius:50%;pointer-events:none;filter:blur(50px);opacity:.8;will-change:transform;background:radial-gradient(circle,rgba(249,115,22,.26) 0%,rgba(236,72,153,.16) 50%,transparent 75%)}
  .gw-star{position:absolute;width:3px;height:3px;border-radius:50%;background:#fff;opacity:.3;animation:gwTwinkle 3.5s infinite;pointer-events:none}
  @keyframes gwTwinkle{0%,100%{opacity:.12}50%{opacity:.55}}
  @media (max-width:640px){.gw-glow{width:380px;height:380px}.gw-glow2{width:220px;height:220px}}
  /* ── ترانزيشن ناعم عام: بيسلّس أي هوفر موجود في الموقع كله ── */
  button,a{transition:transform .22s cubic-bezier(.2,.8,.3,1),box-shadow .22s,background .25s,color .2s,border-color .22s,opacity .2s}
  @media (prefers-reduced-motion:reduce){.gw-glow,.gw-glow2,.gw-star,.gw-orb{animation:none!important;display:none}}
`;

export const PERM_KEYS = [
  'can_view_dashboard',
  'can_manage_courses',
  'can_manage_lessons',
  'can_manage_services',
  'can_view_customers',
  'can_view_enrollments',
  'can_manage_employees',
  'can_manage_settings',
];

export const DEFAULT_SETTINGS = {
  site_name: 'الجوهرة',
  whatsapp_number: '+201234567890',
  whatsapp_message: 'مرحباً',
  vodafone_number: '01000000000',
  instapay_number: '01000000000',
  bank_account: '',
  address: 'القاهرة، مصر',
  facebook_url: '',
  instagram_url: '',
  youtube_url: '',
  email_contact: '',
};
